  <div class="modal-body" [innerHTML]="safeHtmlContent">
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="bsModalRef.hide()">Close</button>
  </div>
  

  
  
